import {
  adminThemeColorAtom,
  isAdminStorage,
  store,
  userThemeColorAtom,
} from '@/store'
import { getTheme as getThemeOri } from 'packages/theme'

/**
 * 不同角色获取不同的主题色
 * 如果是学生前台界面，获取用户选择的主题色
 * 如果是教师管理界面，获取教师管理界面的主题色
 *
 * @returns theme
 */
export const getTheme = () => {
  const userThemeColor = store.get(userThemeColorAtom)
  const adminThemeColor = store.get(adminThemeColorAtom)

  const isAdmin = store.get(isAdminStorage)
  return getThemeOri(isAdmin ? adminThemeColor : userThemeColor)
}
